if (process.env.APP_TYPE === 'operator') {
  module.exports = require('./MessageDisplayArea_operator.scss');
} else {
  module.exports = require('./MessageDisplayArea_visitor.scss');
}